const l = {
  name: "TurkishLira",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
	.st1{fill-rule:evenodd;clip-rule:evenodd;fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M19,11h-2v5.3l-2,0.7v2.1l2-0.7v1.9l-2,0.7v2.1l2-0.7V29h1c5,0,9-4,9-9h-2c0,3.5-2.6,6.4-6,6.9v-5.2l4-1.3
			v-2.1l-4,1.3v-1.9l4-1.3v-2.1l-4,1.3V11z"/>
		<path class="st1" d="M20,0C9,0,0,9,0,20s9,20,20,20c11,0,20-9,20-20S31.1,0,20,0z M2,20c0-9.9,8.1-18,18-18c9.9,0,18,8.1,18,18
			s-8.1,18-18,18C10.1,38,2,29.9,2,20z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as TurkishLira
};
